import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=329f41b0&"
import script from "./privilege.vue?vue&type=script&lang=tsx&"
export * from "./privilege.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports